import type { FC } from 'react';
import type { MessageBarIntent } from '@fluentui/react-components';
import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';

export interface ServerErrorBannerProps {
  title: string;
  message: string | undefined;
  /** `{entity}-form-server-error` per the data-testid convention (form-standard.context.md §9). */
  testId: string;
  /** Defaults to `error` — the §5 server-error banner. Also reused for the `C-` high-risk/advisory
   *  banners some forms render (pass `warning`). */
  intent?: MessageBarIntent;
}

/** Form-level MessageBar banner — never a raw toast for a field-level error (§5). */
export const ServerErrorBanner: FC<ServerErrorBannerProps> = ({ title, message, testId, intent = 'error' }) => {
  if (!message) return null;
  return (
    <MessageBar intent={intent} data-testid={testId}>
      <MessageBarBody>
        <MessageBarTitle>{title}</MessageBarTitle>
        {message}
      </MessageBarBody>
    </MessageBar>
  );
};
